/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ hostname: NonNullable<unknown> }} Disabled_Websites_Already_Disabled_Limited_Use_EnableInputs */

const en_disabled_websites_already_disabled_limited_use_enable = /** @type {(inputs: Disabled_Websites_Already_Disabled_Limited_Use_EnableInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.hostname} is already disabled by default due to limited compatibility. Use the "Enable with Limited Compatibility" option if needed.`)
};

const es_disabled_websites_already_disabled_limited_use_enable = /** @type {(inputs: Disabled_Websites_Already_Disabled_Limited_Use_EnableInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.hostname} ya está deshabilitado por defecto debido a compatibilidad limitada. Usa la opción "Habilitar con compatibilidad limitada" si es necesario.`)
};

/**
* | output |
* | --- |
* | "{hostname} is already disabled by default due to limited compatibility. Use the \"Enable with Limited Compatibility\" option if needed." |
*
* @param {Disabled_Websites_Already_Disabled_Limited_Use_EnableInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const disabled_websites_already_disabled_limited_use_enable = /** @type {((inputs: Disabled_Websites_Already_Disabled_Limited_Use_EnableInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Disabled_Websites_Already_Disabled_Limited_Use_EnableInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_disabled_websites_already_disabled_limited_use_enable(inputs)
	return en_disabled_websites_already_disabled_limited_use_enable(inputs)
});